module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "partno"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("Part I")])])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "pbreak"
  })]), _c('div', {
    staticClass: "cap"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "fig3"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg4.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "fig3"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Sir Henry Clinton."), _c('br'), _vm._v("Engraving by Alexander H. Ritchie after a painting by John Smart. Author’s collection.")])])]), _c('a', {
    attrs: {
      "id": "fig3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72923e3f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/13_Part01.vue
// module id = 93
// module chunks = 0